import { useEffect } from 'react';

export const useCanonical = (path) => {
  useEffect(() => {
    const baseUrl = 'https://marabout-geneve.ch';
    const url = path === '/' ? baseUrl : `${baseUrl}${path}`;

    let canonical = document.querySelector('link[rel="canonical"]');
    if (canonical) {
      canonical.setAttribute('href', url);
    }

    let ogUrl = document.querySelector('meta[property="og:url"]');
    if (ogUrl) {
      ogUrl.setAttribute('content', url);
    }

    return () => {
      if (canonical) canonical.setAttribute('href', baseUrl);
      if (ogUrl) ogUrl.setAttribute('content', baseUrl);
    };
  }, [path]);
};
